// All content sourced from britcars.us
import { asset } from "./basePath";

export const OWNER = {
  name: "Tim",
  email: "tim@britcars.us",
  tagline: "Caretaker of British Motoring Heritage",
};

export const HERO_IMAGES = {
  primary:
    "https://www.britcars.us/old/1951%20Jowett%20Jupiter/album/slides/WP_20180429_14_29_58_Pro.jpg",
  primaryAlt:
    "https://www.britcars.us/old/1951%20Jowett%20Jupiter/album/slides/WP_20180429_14_34_04_Pro.jpg",
  interior:
    "https://www.britcars.us/old/1951%20Jowett%20Jupiter/album/slides/WP_20160531_12_17_04_Rich.jpg",
  dashboard:
    "https://www.britcars.us/old/1951%20Jowett%20Jupiter/album/slides/WP_20180429_14_30_06_Pro.jpg",
  convoy: asset("/photos/drives-on-the-road.jpg"),
  detail: asset("/photos/morris-minor-cockpit.jpg"),
};

// Tim's photos are bundled into /photos/ at deploy time
export const ROVER_IMAGES = [
  { url: asset("/photos/rover-exterior-front.jpg"), caption: "The Rover P4 75 — fifty years parked, awaiting its second life" },
  { url: asset("/photos/rover-engine-out.jpg"), caption: "Engine and transmission lifted out — restoration begins" },
  { url: asset("/photos/rover-burl-dash.jpg"), caption: "Original burl walnut dashboard — preserved beautifully" },
  { url: asset("/photos/rover-drivers-compartment.jpg"), caption: "Driver's compartment, untouched for fifty years" },
  { url: asset("/photos/rover-rear-bench.jpg"), caption: "Rear bench in original green leather with cream piping" },
  { url: asset("/photos/rover-viking-wheel.jpg"), caption: "Viking head wheel boss & speedometer cluster" },
  { url: asset("/photos/rover-steering-angle.jpg"), caption: "Side angle of the steering wheel and gauges" },
  { url: asset("/photos/rover-glovebox.jpg"), caption: "Wood glove box compartment with original handle" },
  { url: asset("/photos/rover-mahogany-centre.jpg"), caption: "Mahogany centre panel with key escutcheon" },
  { url: asset("/photos/rover-door-card.jpg"), caption: "Door card with chrome window winder & inner pull" },
  { url: asset("/photos/rover-cant-rail.jpg"), caption: "Original wood cant rail showing fifty‑year patina" },
];

// Helper to encode britcars.us URLs (spaces).
// NOTE: after deployment we moved the original site content into /old/,
// so the photos that were hot-linked from britcars.us live there now.
const B = (path) => `https://www.britcars.us/old/${path}`.replace(/ /g, "%20");

export const COLLECTION = [
  {
    slug: "1951-jowett-jupiter",
    year: 1951,
    make: "Jowett",
    model: "Jupiter",
    image: B("1951 Jowett Jupiter/album/slides/WP_20180429_14_29_58_Pro.jpg"),
    link: B("1951 Jowett Jupiter/album/index.html"),
    note: "First in Class — Geneva Concours 2024.",
  },
  {
    slug: "1954-ford-popular",
    year: 1954,
    make: "Ford",
    model: "Popular",
    image: B("1954 Ford Popular/album/slides/TD7_1331.jpg"),
    link: B("1954 Ford Popular/album/index.html"),
    note: "Sit‑up‑and‑beg British economy car.",
    images: [
      { url: B("1954 Ford Popular/album/slides/TD7_1331.jpg"), caption: "Studio rear 3/4 in glorious cornflower blue" },
      { url: B("1954 Ford Popular/album/slides/TED_4983.jpg"), caption: "The 10 HP hood badge and chrome grille strakes" },
      { url: B("1954 Ford Popular/album/slides/TED_4986.jpg"), caption: "Painted steel wheel with Ford hubcap and Firestone tyres" },
    ],
  },
  {
    slug: "1933-wolseley-hornet",
    year: 1933,
    make: "Wolseley",
    model: "Hornet Daytona Special",
    image: asset("/photos/wolseley4.jpg"),
    link: B("1933 Wolseley Hornet Daytona Special/album/index.html"),
    note: "Built when George V was on the throne — chrome, cane‑backed seats, and a Union Jack badge.",
    images: [
      { url: asset("/photos/wolseley4.jpg"), caption: "Front‑on — chrome mesh grille, Union Jack badge, twin headlamps" },
      { url: asset("/photos/wolseley7.jpg"), caption: "Side profile — louvered bonnet, tan interior, wire wheels" },
      { url: asset("/photos/wolseley1.jpg"), caption: "Rear 3/4 — twin aero screens, spare tyre, Rally of the Tests plate" },
      { url: asset("/photos/wolseley2.jpg"), caption: "Detail — chrome and coach paint" },
      { url: asset("/photos/wolseley3.jpg"), caption: "Cockpit — cane‑style seats and burl dash" },
      { url: asset("/photos/wolseley5.jpg"), caption: "Sunlit angle in the driveway" },
      { url: asset("/photos/wolseley6.jpg"), caption: "Chrome radiator cap and 'V' hood ornament" },
      { url: asset("/photos/wolseley8.jpg"), caption: "Wire wheels & running board" },
      { url: asset("/photos/wolseley10.jpg"), caption: "Louvered bonnet detail with leather strap" },
      { url: asset("/photos/wolseley12.jpg"), caption: "Twin windscreens & tonneau" },
    ],
  },
  {
    slug: "1953-sunbeam-talbot",
    year: 1953,
    make: "Sunbeam‑Talbot",
    model: "90 Mk II Drophead",
    image: asset("/photos/sunbeam-talbot-tim-portrait.jpg"),
    link: B("53talbot.com/index.html"),
    note: "1950s gentleman's grand tourer — with the caretaker dressed to match.",
    images: [
      { url: asset("/photos/sunbeam-talbot-tim-portrait.jpg"), caption: "The caretaker in vintage attire — Fuel Fed, autumn" },
      { url: B("Current collection/talbotdrophead300.jpg"), caption: "Rear 3/4 view — burgundy with cream piping" },
    ],
  },
  {
    slug: "1951-alvis-ta21",
    year: 1951,
    make: "Alvis",
    model: "TA 21",
    image: B("1951 Alvis A21/album/slides/Alvis19513 (2).jpeg"),
    link: B("1951 Alvis A21/album/index.html"),
    note: "Burl‑oak dash, coach‑built grace.",
  },
  {
    slug: "1950-morris-minor",
    year: 1950,
    make: "Morris",
    model: "Minor Tourer",
    image: asset("/photos/morris1.jpg"),
    link: B("50mmt.com/index.html"),
    note: "Issigonis' people's convertible — 50 MMT, restored to concours condition.",
    images: [
      { url: asset("/photos/morris1.jpg"), caption: "Front 3/4 outdoors — the 50 MMT plate up front" },
      { url: asset("/photos/morris2.jpg"), caption: "Chrome grille, headlamp and bonnet reflection" },
      { url: asset("/photos/morris3.jpg"), caption: "Rear 3/4 with the black‑and‑silver 50 MMT plate" },
      { url: asset("/photos/morris5.jpg"), caption: "Rear view — Illinois 'MORRIS' plate below" },
      { url: asset("/photos/morris4.jpg"), caption: "Side profile in the driveway" },
      { url: asset("/photos/morris6.jpg"), caption: "Sunlit detail" },
      { url: asset("/photos/morris8.jpg"), caption: "The delicate rear window & folded top hardware" },
      { url: asset("/photos/morris10.jpg"), caption: "Interior cockpit view — cream steering wheel & central speedometer" },
      { url: asset("/photos/morris12.jpg"), caption: "Boot & dashboard details" },
      { url: asset("/photos/morris14.jpg"), caption: "Cream leather, ivory dash, tan piping" },
    ],
  },
  {
    slug: "1934-austin-7",
    year: 1934,
    make: "Austin",
    model: "Seven Touring",
    image: B("1934 Austin 7/album/slides/13.jpg"),
    link: B("1934 Austin 7/album/index.html"),
    note: "The car that motorised Britain.",
  },
  {
    slug: "1952-rover-p4",
    year: 1952,
    make: "Rover",
    model: "P4 75",
    image: ROVER_IMAGES[0].url,
    link: null,
    status: "Current restoration · On the road 2027",
    note: "A rare LHD North American export — preserved for fifty years.",
    images: ROVER_IMAGES,
    story: `This restoration has just started. The car is one of only a few export models — left‑hand‑drive examples sold in North America. It came from a gentleman in Pennsylvania who stored it for fifty years; he intended to restore it himself but never did.

He did, however, do a wonderful job of preserving the car's interior. The wood is in excellent condition, as are the original leather seats and door cards. I hope to have this car on the road in 2027.`,
  },
  {
    slug: "1960-triumph-herald",
    year: 1960,
    make: "Triumph",
    model: "Herald",
    image: B("Current collection/herald200.jpg"),
    link: B("60herald.com/index.html"),
    note: "Featured in the Wall Street Journal.",
  },
  {
    slug: "1949-singer-roadster",
    year: 1949,
    make: "Singer",
    model: "Roadster 9A",
    image: asset("/photos/singer-with-mary-and-richard.jpg"),
    link: B("1949 Singer Roadster 9A/album/index.html"),
    note: "Open‑top post‑war optimism in deep maroon — pictured with Mary and Richard Smyth.",
    images: [
      { url: asset("/photos/singer-with-mary-and-richard.jpg"), caption: "With Mary (in red‑and‑white polka dots) and my artist friend Richard Smyth" },
      { url: B("1949 Singer Roadster 9A/album/slides/IMG_20190413_092139.jpg"), caption: "Rear 3/4 view — deep maroon in the sunlight" },
    ],
  },
  {
    slug: "1962-ford-anglia",
    year: 1962,
    make: "Ford",
    model: "Anglia 105E",
    image: B("1962 Ford Anglia/album/slides/35.jpg"),
    link: B("1962 Ford Anglia/album/index.html"),
    note: "An historic European rally car — and a Harry Potter tribute.",
    story: `In its first life, this Anglia was a competition rally car in the Historic Rally Car Association. It was piloted by a husband‑and‑wife team who campaigned it for many years at professional events across Europe — including Italy and Monte Carlo.

They eventually retired the car when it became too uncomfortable for long rally stages and purchased a Rover instead. They said the Rover was "much more comfortable."

Today the Anglia carries that history on its skin — Vickers Barrow Motor Club stickers, the HERO Brockmoor Challenge badges, an aluminium fuel tank shaped to accommodate twin spare wheels, a Brantz rally timer, a Silva ceiling‑mounted compass, and a Safety Devices roll cage. Underneath: a Weber‑carburettored 1.2 L producing 78 bhp, 1500GT Capri front brakes, a Quaiff LSD rear axle, and Mk1 Cortina springs. A class winner in the Classic Marathon — and second overall in the second Rally of the Tests.

In its second life, it became something gentler — a tribute to the flying Ford Anglia of Hogwarts fame.`,
    images: [
      { url: B("1962 Ford Anglia/album/slides/35.jpg"), caption: "Through the splash — rally plate #21, WPV 175A · GB" },
      { url: B("1962 Ford Anglia/album/slides/34.jpg"), caption: "Italian Dolomites — Passo di Giau at Agordina, Classic Marathon" },
      { url: B("1962 Ford Anglia/album/slides/1.jpg"), caption: "At rest — WPV 175 in the dappled afternoon light" },
      { url: B("1962 Ford Anglia/album/slides/10.jpg"), caption: "Racing seats, blue harnesses, and a hand‑held fire extinguisher" },
      { url: B("1962 Ford Anglia/album/slides/11.jpg"), caption: "The driver's office — period rally fit‑out" },
      { url: B("1962 Ford Anglia/album/slides/15.jpg"), caption: "Brantz Rally Timer — for time‑speed‑distance stages" },
      { url: B("1962 Ford Anglia/album/slides/19.jpg"), caption: "Silva ceiling‑mounted compass with integrated map light" },
      { url: B("1962 Ford Anglia/album/slides/22.jpg"), caption: "HERO Brockmoor Challenge & Vickers Barrow Motor Club badges" },
      { url: B("1962 Ford Anglia/album/slides/29.jpg"), caption: "1.2 L Weber‑carburetted engine rebuilt to 78 bhp" },
      { url: B("1962 Ford Anglia/album/slides/25.jpg"), caption: "Aluminium fuel tank shaped to accept twin spare wheels" },
      { url: B("1962 Ford Anglia/album/slides/2.jpg"), caption: "Rear 3/4 — the iconic reverse‑slope rear window" },
      { url: B("images/harrypotteranglia.png"), caption: "The Harry Potter tribute — its gentler second life" },
    ],
  },
];

export const DRIVES = [
  { img: B("Sunday Drives/cars at Glencoe.jpg"), thumb: B("Sunday Drives/cars at Glencoe300.jpg"), caption: "The Glencoe parking spot" },
  { img: B("Sunday Drives/Donut and coffe stop in Winnetka.jpg"), thumb: B("Sunday Drives/Donut and coffe stop in Winnetka300.jpg"), caption: "Donuts and coffee in Winnetka" },
  { img: B("Sunday Drives/Downtown Skokie.jpg"), thumb: B("Sunday Drives/Downtown Skokie300.jpg"), caption: "Downtown Skokie for pastries" },
  { img: B("Sunday Drives/Get your cars.jpg"), thumb: B("Sunday Drives/Get your cars300.jpg"), caption: "Start your engines" },
  { img: B("Sunday Drives/IMG_20200930_092351.jpg"), thumb: B("Sunday Drives/IMG_20200930_092351300.jpg"), caption: "Some cars out" },
  { img: B("Sunday Drives/lining up.jpg"), thumb: B("Sunday Drives/lining up300.jpg"), caption: "Sunrise drive" },
  { img: B("Sunday Drives/Moving Out.jpg"), thumb: B("Sunday Drives/Moving Out300.jpg"), caption: "On our way" },
  { img: B("Sunday Drives/the only log cabin in Skokie.jpg"), thumb: B("Sunday Drives/the only log cabin in Skokie300.jpg"), caption: "The only log cabin in Skokie" },
  { img: B("Sunday Drives/Arden Courts.jpg"), thumb: B("Sunday Drives/Arden Courts300.jpg"), caption: "Arden Courts" },
];

export const EVENTS = [
  { img: B("events shows/Arden.jpg"), thumb: B("events shows/Arden300.jpg"), caption: "Arden Event 2023" },
  { img: B("events shows/1951-jowett-jupiteratGeneva.jpg"), thumb: B("events shows/1951-jowett-jupiteratGeneva300.jpg"), caption: "Jupiter at Geneva 2024" },
  { img: B("events shows/drivers at Fuelfed.jpg"), thumb: B("events shows/drivers at Fuelfed300.jpg"), caption: "The Drivers at Fuelfed" },
  { img: B("events shows/Plazathanksgiving.jpg"), thumb: B("events shows/Plazathanksgiving300.jpg"), caption: "Fuelfed Thanksgiving at the Plaza" },
  { img: B("events shows/Dunkin2022.jpg"), thumb: B("events shows/Dunkin2022300.jpg"), caption: "Sunday Donut Stop 2022" },
  { img: B("events shows/Frank Lloyd Bridge.jpg"), thumb: B("events shows/Frank Lloyd Bridge300.jpg"), caption: "Singer at the famous bridge" },
  { img: B("events shows/morris-minor Geneva.jpg"), thumb: B("events shows/morris-minor Geneva300.jpg"), caption: "The Morris at Geneva 2024" },
  { img: B("events shows/driving.jpg"), thumb: B("events shows/drivingtoshow300.jpg"), caption: "On the road to Fuelfed" },
  { img: B("events shows/deerfield history show 2021.jpg"), thumb: B("events shows/deerfield history show 2021300.jpg"), caption: "Deerfield History Museum 2021" },
  { img: B("events shows/Geneva2024.jpg"), thumb: B("events shows/Geneva2024300.jpg"), caption: "Wolseley center stage — Geneva 2024" },
  { img: B("events shows/Harry Potter at Fuelfed.jpg"), thumb: B("events shows/Harry Potter at Fuelfed300.jpg"), caption: "Harry Potter Fans, Fuelfed 2024" },
  { img: B("events shows/Fuelfed Lake Forest.jpg"), thumb: B("events shows/Fuelfed Lake Forest300.jpg"), caption: "Lake Forest Fuelfed" },
];

export const PREVIOUS = [
  { img: B("Previously Owned/4.jpg"), caption: "1967 Rolls‑Royce Silver Shadow" },
  { img: B("Previously Owned/54BuickRoadmaster250.jpg"), caption: "1954 Buick Roadmaster — the spark" },
  { img: B("Previously Owned/58 magnett200.jpg"), caption: "1958 MG Magnette" },
  { img: B("Previously Owned/00505_eC1zz35aV1y_1200x900.jpg"), caption: "1961 Austin‑Healey Bugeye Sprite" },
  { img: B("Previously Owned/20160325_151221.jpg"), caption: "1954 Sunbeam Alpine" },
  { img: B("Previously Owned/689_main_l.jpg"), caption: "1992 Mercedes 600 SEL" },
  { img: B("Previously Owned/20170723_135848.jpg"), caption: "1954 Sunbeam‑Talbot Saloon" },
  { img: asset("/photos/sunbeam-alpine-gt.jpg"), caption: "1963 Sunbeam Alpine GT" },
  { img: B("Previously Owned/DSC00658.JPG"), caption: "1967 Sunbeam Alpine" },
  { img: B("1948 Hillman Minx MK 2/album/thumbs/48 Hillman.jpg"), caption: "1948 Hillman Minx Mk II" },
  { img: B("Previously Owned/DSC01339.jpg"), caption: "1972 Mercedes 300 SEL Saloon" },
  { img: B("Previously Owned/Hillman300.jpg"), caption: "1959 Hillman Minx" },
  { img: asset("/photos/singer-9a-roadster.jpg"), caption: "1951 Singer 9A Roadster" },
];

export const MEMORIES = [
  { img: B("Memorablemoments/52351221215_c13681de39_o.jpg"), thumb: B("Memorablemoments/Herald300.jpg"), caption: "Celebrating 10+ years since the Herald rebuild" },
  { img: B("Memorablemoments/52351041243_35148509bf_o.jpg"), thumb: B("Memorablemoments/1Rain300.jpg"), caption: "The worst day for a drophead" },
  { img: B("Memorablemoments/52351117279_fb4657107e_o.jpg"), thumb: B("Memorablemoments/BCS300.jpg"), caption: "Empty lot at BCS says it all" },
  { img: B("Memorablemoments/PXL_20210508_192857119.PORTRAIT.jpg"), thumb: B("Memorablemoments/wedding.jpg"), caption: "Driving a former student to her wedding" },
  { img: B("Memorablemoments/34404.jpeg"), thumb: B("Memorablemoments/IMG-1585.JPG"), caption: "Mayor's Choice Award — Then and Now Show 2023" },
  { img: B("Memorablemoments/IMG_20230924_084100877_HDR.jpg"), thumb: B("Memorablemoments/Mari300.jpg"), caption: "Mary joining us in an era‑correct dress" },
  { img: B("Memorablemoments/65661632_10158609258126632_2746466564558553088_n.jpg"), thumb: B("Memorablemoments/DrivingAustin300.jpg"), caption: "Driving the Austin 7 in costume" },
  { img: B("Memorablemoments/IMG_20241027_104303039.jpg"), thumb: B("Memorablemoments/King300.jpg"), caption: "Knighting worthy guests at Fuelfed" },
  { img: B("Memorablemoments/IMG_20241027_100422512.jpg"), thumb: B("Memorablemoments/georgeV300.jpg"), caption: "Portraying King George V" },
  { img: B("Memorablemoments/IMG_20221030_084806251_HDR.jpg"), thumb: B("Memorablemoments/christmaseve300.jpg"), caption: "Christmas Eve breakfast at Kappy's" },
  { img: B("Memorablemoments/Alvisdash1.jpg"), thumb: B("Memorablemoments/Alvisdash300.jpg"), caption: "Restoring the Alvis dash to burl oak" },
  { img: B("Memorablemoments/Herald 3 2014.jpg"), thumb: B("Memorablemoments/newherald300.jpg"), caption: "Herald photoshoot — published in the WSJ" },
  { img: B("Memorablemoments/35.jpg"), thumb: B("Memorablemoments/Anglia300.jpg"), caption: "Importing a real rally car & Harry Potter tribute" },
  { img: B("Memorablemoments/rain.jpg"), thumb: B("Memorablemoments/rainatfuelfed.jpg"), caption: "Soaked inside and out after Fuelfed" },
  { img: B("Memorablemoments/jupiter tow.jpg"), thumb: B("Memorablemoments/jupiter tow300.jpg"), caption: "Classic cars sometimes have problems" },
  { img: B("Memorablemoments/IMG_20220916_140913753_HDR.jpg"), thumb: B("Memorablemoments/multiple awards.jpg"), caption: "Multiple awards at the British Car Show" },
  { img: B("Memorablemoments/Wolseley and me.jpeg"), thumb: B("Memorablemoments/Tim Now&Then300.jpg"), caption: "First year with the Wolseley at Then and Now" },
];

export const VIDEOS = [
  { title: "Mary dressed for the show — vintage from head to toe", thumb: "https://i.ytimg.com/vi/on4R0gnw844/maxresdefault.jpg", url: "https://youtube.com/shorts/on4R0gnw844" },
  { title: "Alvis Interview", thumb: B("videos/Fort Sheridan400.jpg"), url: "https://www.facebook.com/watch/?v=3246307602276489" },
  { title: "Wolseley Walk Around", thumb: B("videos/Wolseley300.jpg"), url: "https://www.youtube.com/watch?v=tMPFavQO8dg" },
  { title: "Geneva Concours 2024 — First in Class", thumb: B("videos/Genva 277.jpg"), url: B("videos/1951-jowett-jupiter_53946937817.mp4") },
  { title: "Morris Minor Interview", thumb: B("videos/morris300.jpg"), url: "https://www.youtube.com/watch?v=0sHFjpc53Xo" },
  { title: "Triumph Herald Interview", thumb: B("videos/herald300.jpg"), url: "https://www.youtube.com/watch?v=j3AvV0Q1-gk" },
  { title: "The King Arrives", thumb: B("videos/knighthood300.jpg"), url: "https://www.youtube.com/watch?v=aqzLx3dbVh4" },
  { title: "Donut Drive Sunday Morning", thumb: B("videos/alvis300.jpg"), url: "https://www.youtube.com/watch?v=y4a_DPNlKfM" },
  { title: "Driving in Lake Forest", thumb: B("videos/drive300.jpg"), url: "https://www.youtube.com/watch?v=SQw4urBW5vU" },
  { title: "Spring Start Up", thumb: B("videos/startup.jpg"), url: "https://www.youtube.com/watch?v=fA7hkIWN1wc" },
  { title: "First Drive", thumb: B("videos/startup 2.jpg"), url: "https://www.youtube.com/watch?v=F55hm1nRkw8" },
  { title: "Driving the Wolseley", thumb: B("videos/Wolseleydriving300.jpg"), url: "https://www.youtube.com/watch?v=dDVlDVCKPVU" },
  { title: "Arrival at Fuelfed", thumb: B("videos/arrive at Fuelfed.jpg"), url: "https://www.youtube.com/shorts/iUP0K7BUyNw" },
];

export const ABOUT_STORY = `Back in the 1980s, while visiting my parents' condo, I noticed several classic cars in the underground parking lot. A 1954 Buick Roadmaster caught my eye, and that moment sparked my hobby of collecting classic cars. Over time, I decided to focus on British cars, as they offer a wide variety of unique models and types. I made many mistakes along the way, often buying at high prices and selling my mistakes at a loss.

Now, I have settled on my current collection of British cars, which are quite rare and possess their own charm. While they are moderately valuable, I realize they will never be a great investment. Every time I step into the garage, I smile and feel grateful for my good health, which allows me to continue enjoying this hobby. I also cherish the friendships I've built, as we often drive to shows, special events, and participate in the famous "donut drives".`;

export const ROADMASTER_STORY = `I purchased the 1954 Buick Roadmaster when I saw it stored in my parents' condo garage. I had it shipped to me in Skokie.

In the trunk, I found receipts for work on the car dating back to the 1950s. The car had been owned by a school teacher who had lived in San Francisco. She owned the car for thirty‑four years. She drove it about four thousand miles per year — which meant the odometer reading wasn't 36,000 but 136,000 miles.

In 1985, she moved to Minnesota and had the car serviced and painted in Mankato, Minnesota. I tried to find more information about her, but sadly, I could not.

I owned the Roadmaster for over a decade and won dozens of trophies at car shows. I detailed the engine and replaced every nut and bolt in the engine compartment. The interior was in excellent condition, and the seats had been covered with a vinyl‑type plastic.

It was at those very car shows that I began to notice the British cars. When I finally sold the Roadmaster, I joined the Morris Minor Car Club and started looking for a Morris Minor.

And that is how an American classic, with a Californian schoolteacher's history hidden in its trunk, quietly turned a hobbyist into a caretaker of British motoring heritage.`;

// Richard Smyth — a British artist (richardsmyth.net) who learned to drive
// in the UK using a Herald. He has painted several of the cars at Fuel Fed shows.
export const ARTWORK = [
  {
    slug: "herald-watercolor",
    artist: "Richard Smyth",
    year: 2014,
    title: "Triumph Herald — Strawberry Sorbet",
    subject: "1960 Triumph Herald Convertible",
    image: B("60herald.com/images/web_herald.jpg"),
    note: "Painted at a Fuel Fed car show on the 28th of September, 2014. Signed lower right.",
  },
  {
    slug: "alvis-watercolor",
    artist: "In the manner of Richard Smyth",
    year: null,
    title: "Alvis TA 21 — Coach‑Built in Green",
    subject: "1951 Alvis TA 21",
    image: B("1951 Alvis A21/album/slides/Alvis19513 (2).jpeg"),
    note: "A digital watercolor of the coach‑built Alvis in front 3/4, signed lower right.",
  },
  {
    slug: "anglia-harry-potter",
    artist: "Fan tribute — artist unknown",
    year: null,
    title: "The Flying Ford Anglia",
    subject: "1962 Ford Anglia 105E",
    image: B("images/harrypotteranglia.png"),
    note: "A Harry Potter‑inspired tribute — the flying Ford Anglia of Hogwarts fame. Displayed as a nod to the Anglia's gentler second life.",
  },
];
